module.exports = __webpack_public_path__ + "71991ccc449c2a6b0f9d0b2dc9ba8d3b.jpg";